import { errorToast, successFormToast } from "./toastify";

function tfToFaDigits(num) {
  const fa = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  return String(num).replace(/[0-9]/g, (d) => fa[d]);
}

function testimonialExperienceForm() {
  const form = document.getElementById("tf-form");
  if (!form) return;

  const steps = Array.from(form.querySelectorAll(".tf-step"));
  const totalSteps = steps.length;
  let currentStep = 1;

  const prevBtn = document.getElementById("tf_prev_btn");
  const nextBtn = document.getElementById("tf_next_btn");
  const submitBtn = document.getElementById("tf_submit_btn");
  const progressFill = form.querySelector(".tf-progress-fill");
  const progressLabel = form.querySelector(".tf-current-step");
  const progressTotal = form.querySelector(".tf-total-steps");
  const progressBar = form.querySelector(".tf-progress-bar");

  if (progressTotal) {
    progressTotal.textContent = tfToFaDigits(totalSteps);
  }

  const starGroups = form.querySelectorAll(".tf-stars");
  starGroups.forEach((group) => {
    const hiddenInput = group.parentElement.querySelector(
      `input[type="hidden"][name="${group.dataset.name}"]`,
    );
    const stars = Array.from(group.querySelectorAll(".tf-star"));

    function paint(value) {
      stars.forEach((star) => {
        star.classList.toggle(
          "is-filled",
          parseInt(star.dataset.value, 10) <= value,
        );
      });
    }

    paint(5);

    stars.forEach((star) => {
      star.addEventListener("click", () => {
        const value = parseInt(star.dataset.value, 10);
        hiddenInput.value = value;
        paint(value);
      });
      star.addEventListener("mouseenter", () => {
        paint(parseInt(star.dataset.value, 10));
      });
    });

    group.addEventListener("mouseleave", () => {
      paint(parseInt(hiddenInput.value, 10) || 5);
    });
  });

  const otherFields = Array.from(form.querySelectorAll("[data-show-when]"));

  function updateOtherFields() {
    otherFields.forEach((wrap) => {
      const [fieldName, expectedValue] = wrap.dataset.showWhen.split("=");
      const checked = form.querySelector(`input[name="${fieldName}"]:checked`);
      const show = checked && checked.value === expectedValue;
      wrap.hidden = !show;
      const input = wrap.querySelector("input");
      if (input) {
        input.required = !!show;
        if (!show) input.value = "";
      }
    });
  }

  form.addEventListener("change", updateOtherFields);
  updateOtherFields();

  function showStep(stepNumber) {
    steps.forEach((stepEl) => {
      stepEl.classList.toggle(
        "is-active",
        parseInt(stepEl.dataset.step, 10) === stepNumber,
      );
    });

    prevBtn.hidden = stepNumber === 1;
    nextBtn.hidden = stepNumber === totalSteps;
    submitBtn.hidden = stepNumber !== totalSteps;

    if (progressLabel) {
      progressLabel.textContent = tfToFaDigits(stepNumber);
    }
    if (progressFill) {
      progressFill.style.width = `${(stepNumber / totalSteps) * 100}%`;
    }
    if (progressBar) {
      progressBar.setAttribute("aria-valuenow", String(stepNumber));
      progressBar.setAttribute("aria-valuemax", String(totalSteps));
    }

    form.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function validateCurrentStep() {
    const stepEl = steps[currentStep - 1];

    if (currentStep === 1) {
      const phoneInput = document.getElementById("tf_phone");
      if (!/^09\d{9}$/.test(phoneInput.value.trim())) {
        phoneInput.setCustomValidity("شماره همراه را به‌درستی وارد کنید.");
        phoneInput.reportValidity();
        phoneInput.setCustomValidity("");
        return false;
      }
    }

    const invalid = stepEl.querySelector(":invalid");
    if (invalid) {
      invalid.reportValidity();
      return false;
    }

    return true;
  }

  nextBtn.addEventListener("click", () => {
    if (!validateCurrentStep()) return;
    if (currentStep < totalSteps) {
      currentStep++;
      showStep(currentStep);
    }
  });

  prevBtn.addEventListener("click", () => {
    if (currentStep > 1) {
      currentStep--;
      showStep(currentStep);
    }
  });

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    if (!validateCurrentStep()) return;

    const submitMsg = document.getElementById("tf_submit_msg");
    submitBtn.disabled = true;
    submitMsg.textContent = "در حال ارسال...";
    submitMsg.classList.remove("is-error");

    const formData = new FormData(form);
    formData.append("nonce", rest_details.nonce);

    jQuery(($) => {
      $.ajax({
        url: rest_details.url + "cynApi/v1/experienceForm",
        type: "post",
        cache: false,
        processData: false,
        contentType: false,
        data: formData,
        success: (res) => {
          if (res.success) {
            form.innerHTML =
              '<div class="tf-success">' +
              (res.data?.message ||
                "با تشکر از شما؛ تجربه‌تان پس از بررسی در سایت منتشر می‌شود.") +
              "</div>";
          } else {
            submitMsg.textContent =
              res.data?.message || "خطا در ثبت نظر. دوباره تلاش کنید.";
            submitMsg.classList.add("is-error");
            submitBtn.disabled = false;
          }
        },
        error: (err) => {
          const message =
            err.responseJSON?.data?.message ||
            "خطا در ارتباط با سرور. دوباره تلاش کنید.";
          submitMsg.textContent = message;
          submitMsg.classList.add("is-error");
          submitBtn.disabled = false;
        },
      });
    });
  });

  showStep(currentStep);
}

testimonialExperienceForm();
